























































































import { Component, Vue } from "vue-property-decorator";
import { toCanvas, QRCodeRenderersOptions } from "qrcode";
import { AppStore } from "@/store";
import { SurveyForm } from "@/models/SurveyForm";
import { serializeSurveyForm } from "@/serialization/serialization";
import moment from "moment";

@Component({})
export default class QRView extends Vue {
  readonly QR_ERROR_CORRECTION_LEVEL = "L";
  readonly QR_DISPLAY_MARGIN = 25; // px
  readonly QR_SIZE_RATE_MIN = 0.2;
  readonly QR_SIZE_RATE_MAX = 1.0;
  readonly QR_SIZE_RATE_STEP = 0.1;

  showExsitDialog = false;
  showQR = false;
  qrSizeRate = this.QR_SIZE_RATE_MAX;
  baselineQRWidth!: number;
  ExsitDisplay = true;

  mounted() {
    const surveyFormJson = localStorage.getItem(AppStore.__SurveyForm__);
    if (surveyFormJson !== null) {
      const surveyForm = JSON.parse(surveyFormJson) as SurveyForm;
      const passportid = this.$route.query.passport;
      const qrData = serializeSurveyForm(surveyForm, passportid);
      const canvas = this.$refs.canvas as HTMLCanvasElement;
      const option: QRCodeRenderersOptions = {
        errorCorrectionLevel: this.QR_ERROR_CORRECTION_LEVEL
      };
      this.setDisplayLanguage();
      //接頭辞がAQS_HRの時、終了ボタンを非表示にする
      const qrprefixData = surveyForm.qrPrefix;
      if (qrprefixData == "AQS_HR") {
        this.ExsitDisplay = false;
      }
      //公開鍵をクエリから取得
      const publickeyData = this.$route.query.public_key;
      //公開鍵がないとき、平文をQR化
      if (publickeyData == undefined) {
        console.log("平文", qrData);
        this.drawQRString(canvas, qrData, option);
      }
      //公開鍵がある時、暗号文をQR化
      else {
        this.drawQRBuffer(
          canvas,
          Buffer.from(localStorage.getItem("localQRstring") ?? "", "base64"),
          option
        );
      }
      /*
       * QR表示用のcanvasの横幅が端末の画面幅 - QR_DISPLAY_MARGINより大きい場合、
       * canvasの横幅が端末の画面幅 - QR_DISPLAY_MARGINの幅になるように調整
       */
      if (
        Number(canvas.style.width.replace("px", "")) >
        window.screen.width - this.QR_DISPLAY_MARGIN
      ) {
        const width = window.screen.width - this.QR_DISPLAY_MARGIN;
        canvas.style.width = width + "px";
        canvas.style.height = width + "px";
      }
      this.baselineQRWidth = Number(canvas.style.width.replace("px", ""));
      this.showQR = true;
    }
  }

  setDisplayLanguage() {
    const langValue = localStorage.getItem("__SelectedLangValue__") ?? "0";
    this.$i18n.locale = langValue === "0" ? "ja" : "en";
  }

  drawQRString(
    canvas: HTMLCanvasElement,
    text: string,
    option: QRCodeRenderersOptions
  ) {
    toCanvas(canvas, text, option, function(error) {
      if (error) console.error(error);
    });
  }

  drawQRBuffer(
    canvas: HTMLCanvasElement,
    text: Buffer,
    option: QRCodeRenderersOptions
  ) {
    toCanvas(canvas, [{ data: text, mode: "byte" }], option, function(error) {
      if (error) console.error(error);
    });
  }

  qrdownload() {
    const canvas = this.$refs.canvas as HTMLCanvasElement;
    const link = document.createElement("a");
    link.href = canvas.toDataURL("image/png");
    link.download = "qrcode_" + moment().format("YYYYMMDD_HHmmss") + ".png";
    link.click();
  }

  zoomOut() {
    let nextQRSizeRate = this.qrSizeRate - this.QR_SIZE_RATE_STEP;
    if (nextQRSizeRate < this.QR_SIZE_RATE_MIN) {
      nextQRSizeRate = this.QR_SIZE_RATE_MIN;
    }
    this.qrSizeRate = nextQRSizeRate;
    this.resizeQR(this.qrSizeRate);
  }

  zoomIn() {
    let nextQRSizeRate = this.qrSizeRate + this.QR_SIZE_RATE_STEP;
    if (nextQRSizeRate > this.QR_SIZE_RATE_MAX) {
      nextQRSizeRate = this.QR_SIZE_RATE_MAX;
    }
    this.qrSizeRate = nextQRSizeRate;
    this.resizeQR(this.qrSizeRate);
  }

  resizeQR(qrSizeRate: number) {
    const canvas = this.$refs.canvas as HTMLCanvasElement;
    canvas.style.width = this.baselineQRWidth * qrSizeRate + "px";
    canvas.style.height = this.baselineQRWidth * qrSizeRate + "px";
  }

  async toDelete() {
    const query = Object.assign({}, this.$route.query);
    if (query.passport != undefined) {
      delete query.passport;
    }
    if (query.default_answers != undefined) {
      delete query.default_answers;
    }
    await this.$router.push({
      name: "Delete",
      query: query
    });
  }
}
